import React from 'react';
export function EmpathySection() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-198">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="mx-auto max-w-2xl" data-id="element-200">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-8 font-serif" data-id="element-201">
            Llegás a casa, o estás en medio de la oficina, y sentís que el pecho
            se cierra.
          </h2>
          <div className="space-y-6 text-lg text-slate-600 leading-relaxed" data-id="element-202">
            <p data-id="element-203">
              El corazón galopa sin razón y la cabeza es una radio que no para
              de repetir todo lo que puede salir mal.
            </p>
            <p className="font-medium text-slate-900 border-l-4 border-blue-500 pl-4 italic" data-id="element-204">
              En Argentina, hoy, estar ansiosa parece la norma, pero{' '}
              <strong data-id="element-205">no tiene por qué ser tu cárcel.</strong>
            </p>
            <p data-id="element-206">
              Te dijeron que "respires profundo" o que "no pienses tanto". Pero
              sabemos que cuando el fuego empezó, la lógica no sirve. Intentar
              calmar la mente con la mente es como intentar apagar un incendio
              con un lanzallamas.
            </p>
            <p className="text-xl font-serif text-slate-800 pt-4" data-id="element-207">
              Necesitás una entrada física. Un interruptor.
            </p>
          </div>
        </div>
      </div>
    </section>;
}